import { jsx } from "react/jsx-runtime";
import CalculatorLayout from "../CalculatorLayout/CalculatorLayout.esm.js";
import { DataProvider } from "./RentVsBuyDataProvider.esm.js";
import ChartContent from "./components/ChartContent/ChartContent.esm.js";
import CustomScrollSection from "./components/CustomScrollSection/CustomScrollSection.esm.js";
const toFiniteFloat = (s) => {
  if (s === void 0) return void 0;
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : void 0;
};
const toFiniteInt = (s) => {
  if (s === void 0) return void 0;
  const n = parseInt(s, 10);
  return Number.isFinite(n) ? n : void 0;
};
const RentVsBuyCalculator = ({
  purchasePrice,
  downPaymentPercent,
  monthlyRent,
  mortgageRate,
  regionId
}) => {
  return /* @__PURE__ */ jsx(DataProvider, { initialPurchasePrice: toFiniteFloat(purchasePrice), initialDownPaymentPercent: toFiniteFloat(downPaymentPercent), initialMonthlyRent: toFiniteFloat(monthlyRent), initialMortgageRate: toFiniteFloat(mortgageRate), regionId: toFiniteInt(regionId), children: /* @__PURE__ */ jsx(CalculatorLayout, { fields: /* @__PURE__ */ jsx(CustomScrollSection, {}), content: /* @__PURE__ */ jsx(ChartContent, {}), cssOverride: {
    marginTop: "token(spacing.400)"
  } }) });
};
export {
  RentVsBuyCalculator as default
};
